<template>
  <div class="bg-white rounded-lg shadow p-4 text-sm space-y-2">
    <div class="flex items-start justify-between gap-2">
      <div class="text-base font-semibold text-dark-primary">{{ name || '--' }}</div>
      <component :is="collapsible ? 'button' : 'div'" class="flex shrink-0 items-center gap-1" @click="collapsible && (open = !open)">
        <span v-if="relationship.is_primary_contact" class="px-2 py-0.5 rounded-full bg-accent-primary/10 text-xs text-accent-primary">Primary</span>
        <span v-if="relationship.is_verified" class="px-2 py-0.5 rounded-full bg-green-100 text-xs text-green-700">Verified</span>
        <ChevronDownIcon v-if="collapsible" class="h-5 w-5 text-dark-primary transition-transform" :class="{ 'rotate-180': open }" />
      </component>
    </div>
    <template v-if="open">
    <div class="grid grid-cols-3 gap-x-2 gap-y-1">
      <template v-for="row in allRows" :key="row.label">
        <div class="text-gray-500">{{ row.label }}</div>
        <a v-if="row.value && row.href" :href="row.href" :target="row.external ? '_blank' : null" rel="noopener" class="col-span-2 break-words text-accent-primary">{{ row.value }}</a>
        <div v-else class="col-span-2 break-words">{{ row.value || '--' }}</div>
      </template>
    </div>
    <div v-for="note in allNotes" :key="note.label">
      <div class="text-gray-500">{{ note.label }}</div>
      <MobileClampedText :text="note.value" />
    </div>
    </template>
  </div>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue';
import { ChevronDownIcon } from '@heroicons/vue/20/solid';
import MobileClampedText from '@/components/mobile/base/MobileClampedText.vue';

const props = defineProps({
  name: String,
  collapsible: Boolean,
  relationship: { type: Object, required: true },
  rows: { type: Array, default: () => [] },
  rowsAfterPhone: { type: Array, default: () => [] },
  notes: { type: Array, default: () => [] },
})

const open = ref(true)

const allRows = computed(() => {
  const relationship = props.relationship
  return [
    ...props.rows,
    { label: 'Title', value: relationship.title },
    { label: 'Email', value: relationship.email_address, href: `mailto:${relationship.email_address}` },
    { label: 'Phone', value: relationship.phone_number, href: `tel:${relationship.phone_number}` },
    ...props.rowsAfterPhone,
  ].filter(row => row.value || !row.hideIfEmpty)
})

const allNotes = computed(() => [{ label: 'Notes', value: props.relationship.contact_notes }, ...props.notes].filter(note => note.value))
</script>
